import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import {CircularProgress, Backdrop} from '@ui';
import {withApollo} from 'react-apollo';
import {getLink} from '@appComponents/Link';
import {ArgosJobHistoryModal} from '@modules/events/components/ArgosSubpartsContent/ArgosJobHistoryModal';
import {ArgosStreamHistoryModal} from '@modules/events/components/ArgosSubpartsContent/ArgosStreamHistoryModal';
import {GetArgosJobLiveHistory} from '@graphql/argosJob/query';
import {renderModalError} from '@utils/forms';
import {showModal} from '@utils/modal';

const HISTORY_TYPE_JOB = 'job';
const ARGOS_JOB_ENTITY_NAME = 'Argos job';

export const ArgosJobLiveControlHistoryLoader = ({client, jobId, type}) => {
    const [job, setJob] = useState(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let cancelled = false;

        if (!jobId) {
            setFailed(true);
            showModal({
                isVisible: true,
                content: renderModalError(
                    ARGOS_JOB_ENTITY_NAME,
                    getLink('argosJobLiveControl.index')
                ),
            });

            return undefined;
        }

        client.query({
            query: GetArgosJobLiveHistory,
            variables: {id: jobId},
            fetchPolicy: 'network-only',
        }).then((result) => {
            if (cancelled) {
                return;
            }

            const loadedJob = result.data?.argosJob;

            if (!loadedJob) {
                setFailed(true);
                showModal({
                    isVisible: true,
                    content: renderModalError(
                        ARGOS_JOB_ENTITY_NAME,
                        getLink('argosJobLiveControl.index')
                    ),
                });

                return;
            }

            setJob(loadedJob);
        }).catch(() => {
            if (cancelled) {
                return;
            }

            setFailed(true);
            showModal({
                isVisible: true,
                content: renderModalError(
                    ARGOS_JOB_ENTITY_NAME,
                    getLink('argosJobLiveControl.index')
                ),
            });
        });

        return () => {
            cancelled = true;
        };
    }, [client, jobId]);

    if (failed) {
        return null;
    }

    if (!job) {
        return (
            <Backdrop open >
                <CircularProgress />
            </Backdrop>
        );
    }

    if (HISTORY_TYPE_JOB === type) {
        return <ArgosJobHistoryModal jobId={jobId} job={job}/>;
    }

    return <ArgosStreamHistoryModal jobId={jobId} job={job}/>;
};

ArgosJobLiveControlHistoryLoader.propTypes = {
    client: PropTypes.shape({
        query: PropTypes.func.isRequired,
    }).isRequired,
    jobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.oneOf(['job', 'stream']).isRequired,
};

export default withApollo(ArgosJobLiveControlHistoryLoader);
